(function () {
  'use strict';

  var CURRENCY_LABELS = {
    TRY: 'Turkish Lira',
    USD: 'US Dollar',
    EUR: 'Euro'
  };

  var CURRENCY_ORDER = ['TRY', 'USD', 'EUR'];

  function initPaymentPage(root) {
    if (!root || root.dataset.vpPaymentInit === 'true') return;
    root.dataset.vpPaymentInit = 'true';

    var toast = root.querySelector('[data-vp-toast]');
    var accountsRoot = root.querySelector('[data-accounts-root]');
    var searchInput = root.querySelector('[data-account-search]');
    var currencyTabs = root.querySelectorAll('[data-currency-tab]');
    var accounts = [];

    try {
      var dataEl = root.querySelector('[data-bank-accounts-json]');
      accounts = dataEl ? JSON.parse(dataEl.textContent) : [];
    } catch (e) {
      accounts = [];
    }

    function showToast(message) {
      if (!toast) return;
      toast.textContent = message;
      toast.classList.add('is-visible');
      window.clearTimeout(showToast._timer);
      showToast._timer = window.setTimeout(function () {
        toast.classList.remove('is-visible');
      }, 2400);
    }

    function copyText(text, label) {
      if (!text) return;
      var done = function () {
        showToast((label || 'Text') + ' copied');
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(done).catch(function () {
          fallbackCopy(text, done);
        });
      } else {
        fallbackCopy(text, done);
      }
    }

    function fallbackCopy(text, cb) {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.position = 'absolute';
      ta.style.left = '-9999px';
      document.body.appendChild(ta);
      ta.select();
      try {
        document.execCommand('copy');
        if (cb) cb();
      } catch (e) {
        showToast('Could not copy');
      }
      document.body.removeChild(ta);
    }

    function activeCurrency() {
      var active = root.querySelector('[data-currency-tab].active');
      return active ? active.getAttribute('data-currency-tab') : 'ALL';
    }

    function filterAccounts() {
      var currency = activeCurrency();
      var query = searchInput ? searchInput.value.trim().toLowerCase() : '';
      return accounts.filter(function (acc) {
        if (currency !== 'ALL' && acc.currency !== currency) return false;
        if (!query) return true;
        var hay = [acc.currency, acc.bank, acc.accountName, acc.swift, acc.iban]
          .join(' ')
          .toLowerCase();
        return hay.indexOf(query) !== -1;
      });
    }

    function groupByCurrency(list) {
      var groups = {};
      list.forEach(function (acc) {
        if (!groups[acc.currency]) groups[acc.currency] = [];
        groups[acc.currency].push(acc);
      });
      return groups;
    }

    function escapeHtml(str) {
      return String(str || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    function escapeAttr(str) {
      return String(str || '')
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/\n/g, '&#10;');
    }

    function bankRowHtml(label, value, copyLabel) {
      return (
        '<div class="bank-card__row">' +
        '<div class="bank-card__row-main">' +
        '<p class="bank-card__label">' +
        escapeHtml(label) +
        '</p>' +
        '<p class="bank-card__value">' +
        escapeHtml(value) +
        '</p>' +
        '</div>' +
        '<button type="button" class="bank-copy" data-copy="' +
        escapeAttr(value) +
        '" data-label="' +
        escapeAttr(copyLabel) +
        '" title="Copy ' +
        escapeHtml(label) +
        '">Copy</button>' +
        '</div>'
      );
    }

    function bankCardHtml(acc) {
      var logoHtml = acc.logo
        ? '<img class="bank-card__logo" src="' +
          escapeHtml(acc.logo) +
          '" alt="' +
          escapeHtml(acc.logoAlt || acc.bank) +
          '" loading="lazy" width="42" height="42">'
        : '<span class="bank-card__logo bank-card__logo--placeholder" aria-hidden="true"></span>';

      return (
        '<article class="bank-card" data-currency="' +
        escapeHtml(acc.currency) +
        '">' +
        '<div class="bank-card__head">' +
        logoHtml +
        '<h3 class="bank-card__title">' +
        escapeHtml(acc.bank) +
        '</h3>' +
        '</div>' +
        '<div class="bank-card__rows">' +
        bankRowHtml('Account Name', acc.accountName, 'Account name') +
        bankRowHtml('SWIFT', acc.swift, 'SWIFT code') +
        bankRowHtml('IBAN', acc.iban, 'IBAN') +
        '</div>' +
        '</article>'
      );
    }

    function columnHtml(currency, list) {
      return (
        '<div class="currency-column" data-currency="' +
        escapeHtml(currency) +
        '">' +
        '<div class="currency-column__head">' +
        '<span class="currency-column__code">' +
        escapeHtml(currency) +
        '</span>' +
        '<span class="currency-column__name">' +
        escapeHtml(CURRENCY_LABELS[currency] || currency) +
        '</span>' +
        '</div>' +
        '<div class="currency-column__cards">' +
        list.map(bankCardHtml).join('') +
        '</div>' +
        '</div>'
      );
    }

    function renderAccounts() {
      if (!accountsRoot) return;

      var list = filterAccounts();
      var currency = activeCurrency();
      var currencies =
        currency === 'ALL'
          ? CURRENCY_ORDER
          : CURRENCY_ORDER.filter(function (code) {
              return code === currency;
            });

      accountsRoot.classList.toggle('is-single-column', currency !== 'ALL');

      if (!list.length) {
        accountsRoot.innerHTML =
          '<div class="account-empty">No bank accounts match your search.</div>';
        return;
      }

      var groups = groupByCurrency(list);
      var html = currencies
        .map(function (code) {
          var columnAccounts = groups[code] || [];
          if (!columnAccounts.length) return '';
          return columnHtml(code, columnAccounts);
        })
        .filter(Boolean)
        .join('');

      accountsRoot.innerHTML =
        html ||
        '<div class="account-empty">No bank accounts match your search.</div>';
    }

    currencyTabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        currencyTabs.forEach(function (t) {
          t.classList.remove('active');
          t.setAttribute('aria-selected', 'false');
        });
        tab.classList.add('active');
        tab.setAttribute('aria-selected', 'true');
        renderAccounts();
      });
    });

    if (searchInput) {
      searchInput.addEventListener('input', renderAccounts);
    }

    root.addEventListener('click', function (e) {
      var copyBtn = e.target.closest('[data-copy]');
      if (copyBtn) {
        e.preventDefault();
        copyText(copyBtn.getAttribute('data-copy'), copyBtn.getAttribute('data-label'));
        return;
      }
      var copyCompanyBtn = e.target.closest('[data-copy-company]');
      if (copyCompanyBtn) {
        e.preventDefault();
        copyText(copyCompanyBtn.getAttribute('data-copy-company'), 'Company details');
        return;
      }
      var copyLinkBtn = e.target.closest('[data-copy-link]');
      if (copyLinkBtn) {
        e.preventDefault();
        copyText(window.location.href, 'Page link');
        return;
      }
      var printBtn = e.target.closest('[data-print]');
      if (printBtn) {
        e.preventDefault();
        window.print();
        return;
      }
      var shareBtn = e.target.closest('[data-native-share]');
      if (shareBtn) {
        e.preventDefault();
        var title = shareBtn.getAttribute('data-share-title') || document.title;
        var text = shareBtn.getAttribute('data-share-text') || '';
        if (navigator.share) {
          navigator
            .share({ title: title, text: text, url: window.location.href })
            .catch(function () {});
        } else {
          copyText(window.location.href, 'Page link');
        }
      }
    });

    renderAccounts();
  }

  function boot() {
    document.querySelectorAll('[data-vp-payment-page]').forEach(initPaymentPage);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-vp-payment-page]');
    if (root) initPaymentPage(root);
  });
})();
